function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(2 1)",
  stroke: "#FFF",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("circle", {
  cx: 42.601,
  cy: 11.462,
  r: 5,
  fillOpacity: 1,
  fill: "#ff1744"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  begin: "0s",
  dur: "1.3s",
  values: "1;0;0;0;0;0;0;0",
  calcMode: "linear",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 49.063,
  cy: 27.063,
  r: 5,
  fillOpacity: 0,
  fill: "#ffab40"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  begin: "0s",
  dur: "1.3s",
  values: "0;1;0;0;0;0;0;0",
  calcMode: "linear",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 42.601,
  cy: 42.663,
  r: 5,
  fillOpacity: 0,
  fill: "#ffff00"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  begin: "0s",
  dur: "1.3s",
  values: "0;0;1;0;0;0;0;0",
  calcMode: "linear",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 49.125,
  r: 5,
  fillOpacity: 0,
  fill: "#c6ff00"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  begin: "0s",
  dur: "1.3s",
  values: "0;0;0;1;0;0;0;0",
  calcMode: "linear",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 11.399,
  cy: 42.663,
  r: 5,
  fillOpacity: 0,
  fill: "#00e5ff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  begin: "0s",
  dur: "1.3s",
  values: "0;0;0;0;1;0;0;0",
  calcMode: "linear",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 4.938,
  cy: 27.063,
  r: 5,
  fillOpacity: 0,
  fill: "#00b0ff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  begin: "0s",
  dur: "1.3s",
  values: "0;0;0;0;0;1;0;0",
  calcMode: "linear",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 11.399,
  cy: 11.462,
  r: 5,
  fillOpacity: 0,
  fill: "#2979ff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  begin: "0s",
  dur: "1.3s",
  values: "0;0;0;0;0;0;1;0",
  calcMode: "linear",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 5,
  r: 5,
  fillOpacity: 0,
  fill: "#d500f9"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  begin: "0s",
  dur: "1.3s",
  values: "0;0;0;0;0;0;0;1",
  calcMode: "linear",
  repeatCount: "indefinite"
}))));

var SvgSpinner = function SvgSpinner(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 58 58",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSpinner, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/spinner.15830fbb.svg";
export { ForwardRef as ReactComponent };